var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{class:[_vm.name]},[_vm._v("\n  "+_vm._s(_vm.copy)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }